import { Autocomplete } from "@mui/material";
import React from "react";
import TreffasTextField from "./TreffasTextField";
import Itnl from "src/utils/Itnl";
import TreffasStyle from "src/utils/TreffasStyle";

const MobileCodes = ({ value, setValue, disabled = false }) => {
  return (
    <Autocomplete
      onChange={(e, value) => setValue(value)}
      value={value}
      isOptionEqualToValue={(option, value) => option.name === value.name}
      getOptionLabel={(option) => `${option.dialCode} ${option.name}`}
      options={Itnl.dialcodes}
      renderOption={(props, option) => {
        return (
          <li {...props} key={option.isoCode}>
            {option.dialCode} {"-"} {option.name}
          </li>
        );
      }}
      disabled={disabled}
      disableClearable
      sx={{
        "& .MuiAutocomplete-inputRoot": {
          height: "44px",
          padding: "0px 8px  !important",
        },
      }}
      ListboxProps={{
        sx: {
          fontSize: "14px !important",
          lineHeight: "24px !important",
        },
      }}
      componentsProps={{
        paper: {
          sx: {
            minWidth: "250px",
          },
        },
      }}
      renderInput={(params) => {
        return (
          <TreffasTextField
            variant={"standard"}
            {...params}
            sx={{
              ...TreffasStyle.formInputLarge("autocomplete"),
            }}
            placeholder={"Dial code"}
            InputProps={{
              disableUnderline: true,
              ...params.InputProps,
            }}
          />
        );
      }}
    />
  );
};

export default MobileCodes;
